var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgHome = function SvgHome(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.9 10.51-13.95-7.5-1.85-1.07h-.19l-1.85 1.07L.1 10.51c-.1.05-.13.17-.07.26l.78 1.35c.05.09.17.13.27.07l3.63-1.96.05.08.74 1.26-1.2 1.04v17.27c0 .11.09.2.2.2h23.01a.2.2 0 0 0 .2-.2V10.46l3.22 1.74c.09.05.21.02.27-.07l.78-1.35c.05-.1.02-.22-.08-.27M13 28.44v-9h6v9zm13 0h-5v-10.8a.2.2 0 0 0-.2-.2h-9.6a.2.2 0 0 0-.2.2v10.8H6V9.24l9.9-5.34h.2L26 9.24z"
  })));
};
export default SvgHome;